import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './rogue_earth.css';
import RogueEarth from './RogueEarth';
import utils from '../../core/utils';

class RogueEarthControls extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      numFoes: 2,
      foeMass: 0.1,
      powerUpInterval: 5,
    };
  }

  drawSelectorFor(options) {
    const { key, label, entries, parse, visible } = utils.defaults(options, {
      label: options.key,
      parse: (x) => x,
      visible: true,
    });
    const entryOpts = entries.map((entry) => (
      <option key={key + entry[0]} value={entry[0]}>{entry[1] || entry[0]}</option>
    ));
    const display = visible ? {} : { display: 'none', visibility: 'hidden' };
    return (
      <label htmlFor={key} key={key} style={display} className={s.label}>
        {label}
        <select
          name={key}
          value={this.state[key]}
          onChange={(event) => {
            this.setState({ [key]: parse(event.target.value) });
          }}
        >
          {entryOpts}
        </select>
      </label>
    );
  }

  render() {
    return (
      <div>
        <RogueEarth
          settings={this.state}
        />
        <form className={s.form}>
          {this.drawSelectorFor({
            key: 'numFoes',
            label: 'number of foes',
            entries: [['1'], ['2'], ['3'], ['4'], ['5'], ['6']],
            parse: (x) => parseInt(x, 10),
          })}
          {this.drawSelectorFor({
            key: 'foeMass',
            label: 'foe mass/earth mass',
            entries: [['0.0001', 'basically 0'], ['0.1'], ['0.3'], ['1']],
            parse: parseFloat,
          })}
          {this.drawSelectorFor({
            key: 'powerUpInterval',
            label: 'power up every',
            entries: [['5', '5s'], ['Infinity', 'never']],
            parse: parseFloat,
          })}
        </form>
      </div>
    );
  }
}

export default withStyles(s)(RogueEarthControls);



// WEBPACK FOOTER //
// src/components/RogueEarthControls/RogueEarthControls.js